import { Injectable } from '@angular/core';
import { UsuarioInfoService } from './usuario-info.service';
import { Subject, Observable } from 'rxjs';
import { ApiRequestService } from './api-request.service';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class UploadService {

  progresso = 0;
  public subProgresso = new Subject<number>();

  constructor (    
    private apiRequestService:  ApiRequestService
  ) { }

  postUpload (url: string, file: File) : Observable<any> {   
    return this.apiRequestService.postUpload(url, file);
  }

  async postUploadAsync (url: string, file: File): Promise<any[]> {
    return this.apiRequestService.postUploadAsync(url, file);    
  }

  putUpload (url: string, file: File) : Observable<any> {   
    return this.apiRequestService.putUpload(url, file);
  }

  async putUploadAsync (url: string, file: File): Promise<any[]> {
    return this.apiRequestService.putUploadAsync(url, file);    
  }

}